<template>
  <v-container fluid>
    <PaginationController v-model="monthBillings" getDataActionName="getWeChatBilling"
      :actionPayload="{ organizationKey: selectedOrganization }"
      haveSearchBox
      :showSearchBoxLabel = false
      isPagination
      disabledFooter
      :historyLimit="historyLimit"
      :isRefreshSelect="false" :haveStartDate="true"
      keepKeywordCase ref="weChatBillingTable">
      <template v-slot:dataTable>
        <v-data-table 
          :headers="headers"
          :search="filter" 
          :rows-per-page-items="rowPerPage"
          :items="allBillings"
          item-key="id">
          <template v-slot:items="props">
            <td class="text-xs-left" >
              {{ props.item.operator || '-' }}
            </td>
            <td class="text-xs-left">
              {{ orderStatusList.find(item => item.key === props.item.type) &&  orderStatusList.find(item => item.key === props.item.type).displayName || '-' }}
            </td>
            <td class="text-xs-left">
              <v-layout column>
                <v-flex>
                  <span>{{ $t('amount') }}:</span>
                  <span>{{ props.item.dollar ? '$' : '¥' }}</span>
                  <span>{{ props.item.amount }}</span>
                </v-flex>
              </v-layout>
            </td>
            <td class="text-xs-left">
              <span>{{ props.item.dollar ? '$' : '¥' }}</span>
              <span>{{ props.item.billAmount }}</span>
            </td>
            <td class="text-xs-left">{{ props.item.remark }}</td>
            <td class="text-xs-left">{{ props.item.status ? '已清账' : '未清账' }}</td>
            <td class="text-xs-left">{{ props.item.time && toTimestampString(new Date(props.item.time * 1000)) }}</td>
            <td class="text-xs-left">
              {{ props.item.processStatus }}
            </td>
          </template>
        </v-data-table>
      </template>
      <template v-slot:beforeMenu>
        <v-flex class="ml-2">{{ $t('totalBalance') }}: <span class="money_highlight">{{ '$' + totalBalance }}</span></v-flex>
      </template>
      <template v-slot:beforeSearchBox>
        <v-flex md4 mr-1 v-if="isAdmin">
          <v-select
              :label="$t('organizationName')"
              v-model="selectedOrganization"
              :items="organizations"
              item-text="clientName"
              item-value="clientKey"
              clearable
              small
              ></v-select>
        </v-flex>
        <v-flex md4 mr-1>
          <v-select :label="$t('selectStatus')" :items="orderStatusList" v-model="selectedStatus"
            chipText='displayName' itemText="displayName" itemValue="key" />
        </v-flex>
        <v-flex md4>
          <v-text-field
            append-icon="filter_list"
            :label="$t('keywords')"
            single-line
            clearable
            v-model="filter"
          ></v-text-field>
        </v-flex>
      </template>
      <template v-slot:afterDate>
        <v-flex md4 v-if="isAdmin">
          <v-btn
            small color="primary" @click="clickGroupInfoBtn" :disabled="groupLoading" :loading="groupLoading">
            {{ $t('weChatGroupInfo') }}
          </v-btn>
        </v-flex>
        <v-flex md4>
          <v-btn
            small color="primary" @click="downloadBillings" :disabled="loading || !organizationKey">
            {{ $t('download') }}
          </v-btn>
        </v-flex>
        <v-flex md4>
          <v-tooltip top>
            <template v-slot:activator="tooltip">
              <div v-on="tooltip.on">
                <v-btn small color="primary" title="importFile" :disabled="!organizationKey" :loading="loading" @click="getOrgLatestWeChatBilling">
                  <v-icon dark left small>refresh</v-icon>
                  {{ $t('getOrgLatestWeChatBilling') }}
                </v-btn>
              </div>
            </template>
            {{ $t('getOrgLatestWeChatBilling') }}
          </v-tooltip>
        </v-flex>
      </template>
    </PaginationController>
    <FormSubmitPopup
      v-model="isShowGroupDialog"
      @popupClose="isShowGroupDialog = false"
      :title="$t('download')"
      v-if="isShowGroupDialog"
      :rightMethod="downloadBillings"
      :rightButtonText="$t('submit')"
      large
    >
      <template v-slot:input>
        <v-container>
          <v-text-field
            append-icon="filter_list"
            :label="$t('keywords')"
            single-line
            clearable
            v-model="groupFilter"
          ></v-text-field>
          <v-data-table :items="groupInfoList"
          :search="groupFilter"
          :headers="groupHeaders"
          :pagination.sync="groupPagination"
          :options.sync="options">
            <template v-slot:items="props">
            <td class="text-xs-left" >
              {{ props.item.name}}
            </td>
            <td class="text-xs-left" >
              {{ props.item.status ? '开启' : '关闭' }}
            </td>
            <td class="text-xs-left" >
              {{ props.item.wxid}}
            </td>
            </template> 
          </v-data-table>
        </v-container>
      </template>

    </FormSubmitPopup>
  </v-container>
</template>

<script>

import PaginationController from './PaginationController'
import UploadFileWidget from './UploadFileWidget'
import { timeTools, checkRules, measurementTools, exportListToXlsx } from '../utils/tools'
import ProductWidget from './ProductWidget'
import SelectWidget from './SelectWidget'
import FormSubmitPopup from './FormSubmitPopup'
import DatePicker from './DatePicker'

export default {
  name: 'WeChatBilling',
  components: {
    PaginationController,
    UploadFileWidget,
    SelectWidget,
    ProductWidget,
    FormSubmitPopup,
    DatePicker
  },
  data () {
    return {
      filter: '',
      groupFilter: '',
      pagination: {
        rowsPerPage: 50,
        sortBy: 'time'
      },
      rowPerPage: [25, 50, {text: this.$t('all'), value: 50}],
      groupPagination: {
        rowsPerPage: 50
      },
      loading: false,
      historyLimit: 50,
      orderStatusList: [
        {
          displayName: this.$t('all'),
          key: ''
        },
        {
          displayName: '加账单',
          key: 1
        },
        {
          displayName: '付款',
          key: 2
        },
        {
          displayName: '清账',
          key: 3
        }
      ],
      monthBillings: [],
      selectedStatus: '',
      isShowGroupDialog: false,
      groupLoading: false,
      selectedOrganization: '',
      groupInfoList: [],
      groupHeaders: [{
        text: this.$t('groupName'),
        value: 'name',
        align: 'left',
        sortable: true
      }, {
        text: this.$t('status'),
        value: 'status',
        align: 'left',
        sortable: true
      }, {
        text: this.$t('weChatGroupId'),
        value: 'wxid',
        align: 'left',
        sortable: true  
      }],
      options: {
        itemsPerPage: 25
      },
      isShowWarehouseUploadDialog: false
    }
  },
  mixins: [timeTools, checkRules, measurementTools],
  computed: {
    headers () {
      return [
        { text: this.$t('operator'), value: 'operator', align: 'left', width: '15%' },
        { text: this.$t('type'), value: 'type', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('detail'), value: 'amount', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('remainAmount'), value: 'billAmount', align: 'left', sortable: true, width: '15%' },
        { text: this.$t('note'), value: 'remark', align: 'left', sortable: true, width: '15%' },
        { text: this.$t('status'), value: 'status', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('createTime'), value: 'createTime', align: 'left', sortable: true, width: '35%' }
      ]
    },
    allBillings () {
      let billing = this.monthBillings.reduce((acc, item) => [...acc, ...item.billings], []).sort((a, b) => b.time - a.time)
      return billing.filter(item => {
        let {time} = item
        time = new Date(time * 1000)
        let isValidDate = time > this.startDate && time <= this.endDate 
        let isValidStatus = item.type === this.selectedStatus || this.selectedStatus === ''
        return isValidDate && isValidStatus
      })
    },
    totalBalance () {
      return this.monthBillings[0]?.billings[0]?.billAmount || 0
    },
    organizations () {
      return this.$store.getters.systemBalances.filter(element => {
        return element.clientKey !== '' && element.weChatGroupId
      })
    },
    organizationKey () {
      return this.isAdmin ? this.selectedOrganization : this.$store.getters.activeOrganization
    },
    systemBalance () {
      return (this.isAdmin ? this.$store.getters.systemBalances.find(item => item.clientKey === this.organizationKey) : this.$store.getters.systemBalance) || {}
    },
    latestGetWeChatBillingDate () {
      let time = this.systemBalance.latestGetWeChatBillingDate
      if (time instanceof Date) {
        time = Math.floor(time.getTime() / 1000)
      } else {
        time = time?.seconds
      }
      return time
    },
    weChatGroupId () {
      return this.systemBalance.weChatGroupId
    },
    startDate () {
      return this.toDateStart(new Date(this.$refs.weChatBillingTable.startDateString))
    },
    endDate () {
      return this.toDateEnd(new Date(this.$refs.weChatBillingTable.endDateString)) 
    },
    isAdmin () {
      return !!(this.$store.getters.user || {}).isAdmin
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async getOrgLatestWeChatBilling () {
      this.loading = true
      let unixTimestamp
      if (!this.weChatGroupId) {
        return this.$store.dispatch('showToast', { info: this.$t('needFeatureContactRepresentative'), level: 'error' })
      }
      if (!this.latestGetWeChatBillingDate) {
        let date = new Date().setMonth(new Date().getMonth() - 1)
        unixTimestamp = Math.floor(date / 1000)
      } else {
        unixTimestamp = this.latestGetWeChatBillingDate
      }
      let payload = { wxid: this.weChatGroupId, latestGetWeChatBillingDate: unixTimestamp, organizationKey: this.organizationKey }
      try {
        let result = await this.$store.dispatch('getOrgLatestWeChatBilling', payload)
        this.loading = false
        if (result?.data.length) {
          this.$store.dispatch('showToast', { info: 'success', level: 'success' })
          let billings = this.monthBillings[0]?.billings || []
          let newBillings = billings.concat(result.data)
          this.$set(this.monthBillings, 0, {billings: newBillings})
        } else {
          this.$store.dispatch('showToast', { info: 'no new data', level: 'success' })
        }
      } catch (error) {
        this.loading = false
        this.$store.dispatch('showToast', { info: error })
      }
    },
    async clickGroupInfoBtn () {
      this.groupLoading = true
      const result = await this.$store.dispatch('getWeChatGroupInfo')
      this.groupLoading = false
      this.groupInfoList = result?.data
      this.isShowGroupDialog = true
    },
    async downloadBillings () {
      const headers = ['operator', 'type', 'billingDetail', 'remain', 'status', 'remark', 'createTime']
      let data = this.allBillings.reduce((sum, billing) => {
        let item = Object.assign({}, billing)
        item.status = item.status ? '已清账' : '未清账'
        item.type = this.orderStatusList.find(status => status.key === item.type).displayName
        item.remain = item.billAmount
        item.createTime = this.toTimestampString(new Date(item.time * 1000))
        item.billingDetail = (item.dollar ? '$' : '¥') + item.amount
        let info = headers.map(key => item[key])
        return [...sum, ...[info]]
      }, [])
      const filename = `weChatBilling`
      exportListToXlsx(
        [
          headers,
          ...data
        ], filename
      )
    },
    init () {
      if (this.isAdmin) {
        this.$store.dispatch('getAllSystemBalances')
        const code = prompt('Please input code')
        if (code === null) {
          return this.$router.go(-1)
        }
        if (code !== 'viteusa123') {
          return this.init()
        }
        return code
      }
    }
  }
}
</script>

<style>
.hideInput {
  position: absolute;
  top: 0;
  left: -15px;
  width: 100px;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
.abnormal_list {
  background-color : yellow
}
.money_highlight {
  color: green;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/WeChatBilling.vue